module.exports = __webpack_public_path__ + "static/savinglives_card_img2@2x-53ce31826ec2776bbbc5a813f9c93c7c.jpg";